import React from 'react';
import { FollowersShape, ProfileShape } from '../shapes';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Waiting from './waiting';
import DateMaster from '../stores/utils/date_master';

export default class Followers extends React.Component {

  static propTypes = {
    params: PropTypes.object,
    profile: ProfileShape,
    followers: FollowersShape,
    onLoadProfile: PropTypes.func,
    onLoadFollowers: PropTypes.func
  }

  componentDidMount() {
    if (this.props.profile.get('slug') !== this.props.params.slug) {
      this.props.onLoadProfile(this.props.params.slug);
      this.props.onLoadFollowers(this.props.params.slug);
    }
  }

  render() {
    if (this.props.followers.get('loading') || this.props.profile.get('loading')) {
      return this.renderLoading();
    } else if (this.props.followers.get('error')){
      return this.renderError();
    } else if (this.props.followers.get('followers').size > 0) {
      return this.renderFollowers();
    } else {
      return this.renderNoFollowers();
    }
  }

  renderNoFollowers() {
    const name = this.props.profile.get('name') || this.props.profile.get('slug');

    return (
      <div className='follow-rows'>
        <div className='heading'>
          <h2>{ `Well, nobody follows ${name} yet.` }</h2>
        </div>
        <div className='action'>
          <Link to={ `/people/${this.props.profile.get('slug')}` } className='btn btn-dark'>Ok</Link>
        </div>
      </div>
    );
  }

  renderFollowers() {
    const followers = this.props.followers.get('followers').map((follower, i) => {
      return this.renderSingleFollower(follower, i);
    });

    const name = this.props.profile.get('name') || this.props.profile.get('slug');

    return (
      <div className='follow-rows'>
        <div className='header'>
          <h2>{ `People following ${name}` }</h2>
        </div>
        <div className='followers-group'>
          <ul className='list-group'>{ followers }</ul>
        </div>
        <div className='action'>
          <Link to={ `/people/${this.props.profile.get('slug')}` } className='btn btn-dark'>Ok</Link>
        </div>
      </div>
    );
  }

  renderSingleFollower(follower, index) {
    const name = follower.get('name') || follower.get('slug');
    return (
      <li key={ index } className='list-group-item'>
        <div className='row follow-row'>
          <div className='col-sm-6'>
            <Link to={ `/people/${ follower.get('slug') }` } className='follow-name'>
              { name }
            </Link>
            <div className='item-meta'>{ follower.get('headline') }</div>
          </div>
          <div className='col-sm-3 item-meta'>Followed on: { DateMaster.format(follower.get('followedAt')) }</div>
          <div className='col-sm-3 item-meta'>Tacks: { follower.get('tacksCount') }</div>
        </div>
      </li>
    );
  }

  renderLoading() {
    return(
      <Waiting waitingText={ 'Crunching' } />
    )
  }

  renderError() {
    return (
      <h2>Hmm. It looks like something bad happened. Sorry.</h2>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/followers.jsx